import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ProductDtDemoData } from '../../../../../data/ProductDtDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { handleLoadProductDetailsOpe } from '../ProductOperation';

const ProductDetailsContext = createContext();
export const useProductDt = () => useContext(ProductDetailsContext);

// Currencies to check
const currencies = ['thb', 'usd', 'eur', 'bdt'];

function ProductDetailsProvider({ children, productId }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [productInfo, setProductInfo] = useState(ProductDtDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({ type: '', data: null });
    // -- set package info
    const [packageInfo, setPackageInfo] = useState(ProductDtDemoData?.packages?.[0]);
    // -- set if any package is selected
    const [packageId, setPackageId] = useState(0);

    // -- set true/false if any package is selected
    const [isClicked, setIsClicked] = useState(0);

    const { setMessage } = useTemplate();

    // -- Load invoice info by invoiceId
    useEffect(() => {
        handleLoadProductDetailsOpe(productId)
            .then(({ data }) => {
                setProductInfo(data);
            })
            .catch((err) => {
                setProductInfo({});
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, productId, reloadKey]);

    useEffect(() => {
        // set Package info if any package is selected
        const data = productInfo?.packages?.find((d) => d?.id === packageId);
        setPackageInfo((prevData) => ({ ...prevData, ...data }));
    }, [packageId, productInfo]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setProductInfo(ProductDtDemoData);
            setPackageInfo(ProductDtDemoData?.packages?.[0]);
        };

        // --Handle Package item click
        const handleSelectPackage = (ev, item) => {
            ev.stopPropagation();
            ev.preventDefault();
            setPackageInfo(item);
            setPackageId(item?.id);
            setIsClicked((st) => !st);
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({ type, data });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({ type: '', data: null });
        };

        // --Filter currencies that area already present in package prices table
        const filterCurrency = () => {
            // Currencies to check
            //  const currencies = ['thb', 'usd', 'eur', 'bdt'];

            // Extract all unique currencies from the array of objects
            const uniqueCurrencies = [
                ...new Set(packageInfo?.prices.map((obj) => obj.currency?.toLowerCase()))
            ];

            // Calculate currencies that are not present in any object
            return (
                currencies.filter(
                    (currency) => !uniqueCurrencies.includes(currency?.toLowerCase())
                ) || ['']
            );
        };
        // Calculate currencies that are not present in any object
        const filteredCurrencies = filterCurrency();

        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,
            handleSelectPackage,
            isSelected: packageId > 0,
            // -- invoice info
            productInfo,
            setProductInfo,

            // --set package info
            packageInfo,
            setPackageInfo,
            isClicked,

            // All Handler
            handleReload,

            //
            filteredCurrencies
        };
    }, [isClicked, packageId, packageInfo, productInfo, showModal.data, showModal.type]);

    return (
        <ProductDetailsContext.Provider value={value}>{children}</ProductDetailsContext.Provider>
    );
}

export default ProductDetailsProvider;
